module.exports = __webpack_public_path__ + "media/images/emblems/Birmensdorf-blazon-ef2464185f8eed5560b6d9d1eefc270c.svg";